<template>
    <div>
        <template v-if="order.third_party">
            <div class="row mx-n2 mb-n3">
                <template v-for="registrant in sortedRegistrants">
                    <div class="col-md-6 px-2 mb-3">
                        <RegistrantCard :order="order" :registrant="registrant">
                            <slot :registrant="registrant" />
                        </RegistrantCard>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="card">
                <div class="card-body">
                    <slot :registrant="order.registrants[0]" />
                </div>
            </div>
        </template>
    </div>
</template>


<script>
    import RegistrantCard from "../../RegistrantCard.vue";
    import { sortRegistrants } from "../../../../util/register";

    export default {
        components: {
            RegistrantCard
        },
        props: {
            order: Object,
        },
        computed: {
            sortedRegistrants() {
                return sortRegistrants(this.order.registrants);
            },
        }
    }
</script>
